import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import _VaFileUploadList from './VaFileUploadList.vue'

export const VaFileUploadList = withConfigTransport(_VaFileUploadList)
